import { cn } from "@/lib/utils"

interface KvRowProps {
  k: string
  v: React.ReactNode
  mono?: boolean
}

export function KvRow({ k, v, mono }: KvRowProps) {
  return (
    <div className="flex items-baseline justify-between gap-4 border-b border-grey4 py-1.5">
      <span className="shrink-0 whitespace-nowrap text-[12px] text-grey5">
        {k}
      </span>
      <span
        className={cn(
          "text-right text-[12.5px] text-white",
          mono && "font-mono",
        )}
      >
        {v}
      </span>
    </div>
  )
}
